var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"hiq-exhibition-footer"},[_c('div',{staticClass:"hiq-exhibition-footer__inner",domProps:{"innerHTML":_vm._s(_vm.footer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }